<template>
  <div id="home-cards">
    <v-container v-if="!authenticated" class="py-6">
      <v-row justify="center" align="stretch" class="text-secondary">
        <v-col v-for="(card, i) in cards" :key="i" cols="12" md="4">
          <router-link :to="{ path: '/login' }" class="text-decoration-none">
            <v-card
              flat
              class="pa-6 border rounded-lg transition-card"
              bg-color="background"
              hover
            >
              <v-img
                :src="card.image"
                height="25vh"
                contain
                class="mb-6"
                alt="Card principal"
              />
              <h3
                class="text-h5 font-weight-bold mb-2"
                v-html="card.title"
              ></h3>
              <p
                class="text-body-2 text-center text-secondary mb-6"
                v-html="card.text"
              />
              <v-btn
                color="primary"
                class="text-black"
                append-icon="mdi-arrow-right"
              >
                {{ card.button }}
              </v-btn>
            </v-card>
          </router-link>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid>
      <v-row>
        <v-col
          v-if="!authenticated"
          cols="12"
          md="2"
          class="d-flex justify-sm-center"
        >
          <v-card
            flat
            class="border rounded-lg mt-3 transition-card fixed-item"
            bg-color="background"
            hover
            @click="$emit('openQuotationDialog')"
          >
            <v-img
              :src="require('../../../assets/mascote.png')"
              height="150"
              contain
              class="mb-6"
            />
            <h3 class="text-body-2 font-weight-bold mb-2 px-6">
              Peça exclusiva?
            </h3>
            <p class="text-body-2 text-center text-secondary mb-6">
              Faça uma cotação agora!
            </p>
          </v-card>
        </v-col>

        <!-- Slide Group com setas externas -->
        <v-col cols="12" :md="authenticated ? 12 : 10">
          <div class="sg-wrapper">
            <v-hover v-slot="{ isHovering, props }">
              <div v-bind="props" class="relative">
                <v-slide-group
                  ref="autoSg"
                  v-model="activeIdx"
                  center-active
                  mandatory
                  @mouseenter="autoPaused = true"
                  @mouseleave="autoPaused = false"
                >
                  <v-slide-group-item
                    v-for="(card, i) in trendingCards"
                    :key="card.id || i"
                    :value="i"
                  >
                    <div class="mx-2 carousel-item">
                      <router-link
                        :to="{
                          name: 'ModelDetails',
                          params: { slug: slugify(card.title), id: card.id },
                        }"
                        style="text-decoration: none"
                      >
                        <v-card
                          flat
                          class="border rounded-lg mt-3 transition-card position-relative"
                          bg-color="background"
                          hover
                        >
                          <v-img
                            :key="card.current"
                            :src="card.current"
                            height="150"
                            cover
                            class="mb-6"
                            alt="Imagem do produto"
                            @error="onTrendingImgError(i)"
                          />
                          <h3
                            class="text-body-2 font-weight-bold mb-2 text-truncate px-6"
                            v-html="card.title"
                          />
                          <p
                            class="text-body-2 text-center text-secondary mb-6"
                          >
                            {{ card.price }}
                          </p>
                        </v-card>
                      </router-link>
                    </div>
                  </v-slide-group-item>
                </v-slide-group>

                <!-- SETAS EXTERNAS com transição suave -->
                <v-fade-transition>
                  <v-btn
                    v-if="isHovering"
                    class="sg-arrow sg-arrow--left"
                    icon="mdi-chevron-left"
                    variant="elevated"
                    size="small"
                    @click.stop.prevent="goPrev"
                  />
                </v-fade-transition>

                <v-fade-transition>
                  <v-btn
                    v-if="isHovering"
                    class="sg-arrow sg-arrow--right"
                    icon="mdi-chevron-right"
                    variant="elevated"
                    size="small"
                    @click.stop.prevent="goNext"
                  />
                </v-fade-transition>
              </div>
            </v-hover>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { cardProducts as sourceCards } from "@/constants/trendProducts";

export default {
  name: "CardsHome",
  props: {
    authenticated: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // Cards estáticos do topo
      cards: [
        {
          image: require("@/assets/card-one.png"),
          title: "Lojista: <br /> Faça vendas sem estoque.",
          text: `1 - Anuncie nossos produtos em sua loja.<br />
                 2 - Você vende, atende o cliente e lucra!<br />
                 3 - Nós imprimimos e enviamos o produto.`,
          button: "Quero vender",
        },
        {
          image: require("@/assets/card-two.png"),
          title: "Maker: <br /> Imprima produtos e lucre.",
          text: `1 - Cadastre sua impressora e filamentos no site. <br />
                 2 - Você recebe pedidos, imprime e envia. <br />
                 3 - Você recebe pelas suas impressões!`,
          button: "Quero imprimir",
        },
        {
          image: require("@/assets/card-three.png"),
          title: "Designer:  <br /> Crie modelos 3D e lucre.",
          text: `1 - Envie seus modelos 3D para o site. <br />
                 2 - Lojistas vendem e Makers imprimem. <br />
                 3 - Você recebe comissões para cada venda!`,
          button: "Quero criar",
        },
      ],
      trendingCards: [],
      activeIdx: 1,
      autoTimer: null,
      autoPaused: false,
      intervalMs: 2000,
      step: 1,
      navLock: false,
      navLockMs: 180,
    };
  },

  created() {
    this.trendingCards = (Array.isArray(sourceCards) ? sourceCards : []).map(
      (c) => ({
        ...c,
        preferred: c.imageCompress || c.image || "",
        fallback: c.image || "",
        current: c.imageCompress || c.image || "",
        tried: false,
      })
    );
  },

  computed: {
    currentTheme() {
      return this.$store.state.theme;
    },
  },

  watch: {
    trendingCards(newVal) {
      if (!Array.isArray(newVal) || newVal.length <= 1) {
        this.activeIdx = 1;
        this.stopAutoplay();
        return;
      }
      if (this.activeIdx >= newVal.length) this.activeIdx = 0;
      this.restartAutoplay();
    },
  },

  mounted() {
    const prefersReduced = window.matchMedia?.(
      "(prefers-reduced-motion: reduce)"
    )?.matches;

    if (!prefersReduced && this.trendingCards.length > 1) {
      this.startAutoplay();
      document.addEventListener("visibilitychange", this.onVisibility);
    }
  },

  beforeUnmount() {
    this.stopAutoplay();
    document.removeEventListener("visibilitychange", this.onVisibility);
  },

  methods: {
    onTrendingImgError(idx) {
      const item = this.trendingCards[idx];
      if (!item || item.tried) return;
      item.tried = true;
      item.current = item.fallback;
    },
    goNext() {
      if (this.navLock) return;
      const len = this.trendingCards.length;
      if (len <= 1) return;

      this.activeIdx = (this.activeIdx + 1) % len;
      if (this.activeIdx === len - 1) this.activeIdx = 1;
      this.restartAutoplay();
      this.lockNavTemporarily();
    },
    goPrev() {
      if (this.navLock) return;
      const len = this.trendingCards.length;
      if (len <= 1) return;

      this.activeIdx = (this.activeIdx - 1 + len) % len;
      if (this.activeIdx === 0) this.activeIdx = len - 1;
      this.restartAutoplay();
      this.lockNavTemporarily();
    },
    lockNavTemporarily() {
      this.navLock = true;
      setTimeout(() => (this.navLock = false), this.navLockMs);
    },
    startAutoplay() {
      this.stopAutoplay();
      this.autoTimer = setInterval(() => {
        if (this.autoPaused) return;
        const len = this.trendingCards.length;
        if (len <= 1) return;
        this.activeIdx = (this.activeIdx + this.step) % len;
      }, this.intervalMs);
    },
    stopAutoplay() {
      if (this.autoTimer) {
        clearInterval(this.autoTimer);
        this.autoTimer = null;
      }
    },
    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    },
    onVisibility() {
      if (document.hidden) {
        this.stopAutoplay();
      } else {
        this.startAutoplay();
      }
    },
    slugify(text) {
      return text
        .toString()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[^a-z0-9 ]/g, "")
        .trim()
        .replace(/\s+/g, "-");
    },
  },
};
</script>

<style scoped>
.sg-wrapper {
  position: relative;
}
.sg-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
}
.sg-arrow--left {
  left: 8px;
}
.sg-arrow--right {
  right: 8px;
}

.transition-card {
  transition: box-shadow 0.18s ease, transform 0.18s ease;
}
.transition-card:hover {
  transform: translateY(-6px);
}
.carousel-item {
  width: clamp(220px, 24vw, 200px);
}

.fixed-item {
  width: clamp(220px, 24vw, 200px);
}

:deep(.v-slide-group__prev) {
  display: none;
}
:deep(.v-slide-group__next) {
  display: none;
}

@media screen and (max-width: 537px) {
  .sg-arrow--left {
    display: none;
  }

  .sg-arrow--right {
    display: none;
  }
}
</style>
